import classNames from 'classnames';
import { camelCase } from 'lodash';
import type { FC } from 'react';
import { useCallback, useContext } from 'react';
import { useRef, useState } from 'react';
import React from 'react';

import Address from '../../../components/Address';
import AddressToggle from '../../../components/AddressToggle';
import CartPortal from '../../../components/CartPortal';
import ContentNavigation from '../../../components/ContentNavigation';
import LegalCheckbox from '../../../components/LegalCheckbox';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import ConfigVosContext from '../../../service/context/config-vos';
import useAppStoreVos from '../../../service/store/appVos';
import useOrderStoreVos from '../../../service/store/orderVos';
import { scrollToError, scrollToRef } from '../../../utils/scroll';
import { validateOrderVos } from '../../../utils/validate';

interface IStepCustomerDataProps {
  placeOrder: () => Promise<void>;
}

const StepCustomerData: FC<IStepCustomerDataProps> = ({
  placeOrder
}) => {
  const appContext = useContext(ConfigVosContext);
  const errorRef = useRef<null | HTMLDivElement>(null);
  const [ showErrors, setShowErrors ] = useState(false);
  const { step, setStep } = useAppStoreVos(state => state);

  const {
    order,
    setValue: setOrderValue
  } = useOrderStoreVos(state => state);

  const handleInputChange = useCallback((
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ): void => {
    setOrderValue(event.target.value, event.target.name);
  }, [ setOrderValue ]);

  const handleToggleAddress = (propertyToSet: string, visible: boolean): void => {
    setOrderValue(visible, camelCase(`diff ${propertyToSet}`));
  };
  const validOrder = validateOrderVos(order);

  const handleCtaClick = (): void => {
    if (validOrder && placeOrder) {
      void placeOrder();
      scrollToRef();
    } else {
      setShowErrors(true);
      scrollToError(errorRef);
    }
  };

  return (
    <>
      <ContentNavigation
        step={step}
        setStep={setStep}
        showBackButton
      />
      <div className="box">
        <div className="box-content">
          <div ref={errorRef}>
            {showErrors && !validOrder && (
              <div className="error-box">
                Bitte fülle alle Pflichtfelder aus.
              </div>
            )}
          </div>
          <Address
            showError={showErrors}
            propertyKey="address"
            address={order?.address}
            onChange={handleInputChange}
            showReferenceNumber
            referenceNumberLabel={appContext?.settings?.reference_number_label}
            referenceNumber={order?.reference_number}
            customerNumber={order?.customer_number}
            showCustomerNumber
            showCountrySelect
          />
          <Input
            label="Gutscheincode"
            name="coupon"
            value={order?.coupon || ''}
            onChange={handleInputChange}
            placeholder="Gutscheincode eingeben"
          />
          <AddressToggle
            showError={showErrors}
            title="Abweichender Rechnungsempfänger?"
            propertyKey="invoiceRecipient"
            address={order?.invoiceRecipient}
            showAddress={order?.diffInvoiceRecipient}
            onChange={handleInputChange}
            toggleFunction={handleToggleAddress}
            emailLabel="E-Mail Rechnungsempfänger"
            hideName
            showCountrySelect
          />
          <div className="box-cta">
            <Button
              className={classNames('btn-xl', {
                'btn-disabled': !validOrder
              })}
              onClick={handleCtaClick}
              hasRightIcon
              icon="arrow-right"
              // disabled={!validOrder}
            >
              Jetzt verbindlich beauftragen
            </Button>
          </div>
          <LegalCheckbox
            checked={order?.checkedLegal || false}
            onChange={checked => setOrderValue(checked, 'checkedLegal')}
            hasError={showErrors}
          />
          <CartPortal>
            <Button
              className={classNames('btn-xl', {
                'btn-disabled': !validOrder
              })}
              onClick={handleCtaClick}
              hasRightIcon
              icon="arrow-right"
              // disabled={!validOrder}
            >
              Jetzt verbindlich beauftragen
            </Button>
          </CartPortal>
        </div>
      </div>
    </>
  );
};

export default StepCustomerData;
